// shineAnimation.js
var ShineAnimation = pc.createScript('shineAnimation');

ShineAnimation.attributes.add('shineStartPosition',{type: 'number'});
ShineAnimation.attributes.add('shineEndPosition',{type: 'number'});

var shineAnim;

// initialize code called once per entity
ShineAnimation.prototype.initialize = function() {

ShineAnimation.instance = this;
    shineAnim = this.entity.tween(ShineAnimation.instance.entity.getLocalPosition()).to({ x: ShineAnimation.instance.shineEndPosition, y: 28.979, z: 0 }, 1.3, pc.Linear).on('complete', function () { ShineAnimation.instance.entity.setLocalPosition(new pc.Vec3(ShineAnimation.instance.shineStartPosition, 28.979, 0)); shineAnim.start();});
    shineAnim.start();
    this.entity.on("destroy", this.OnDestroy,this);

};
ShineAnimation.prototype.OnDestroy = function(){
    shineAnim.stop();
    this.entity.off("destroy", this.OnDestroy,this);
};


